import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "comment-section" }
const _hoisted_2 = { class: "comment" }
const _hoisted_3 = { id: "new-comment-editor-wrapper" }
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_offer_button = _resolveComponent("offer-button")!
  const _component_comment = _resolveComponent("comment")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.comments) + " (" + _toDisplayString(_ctx.totalNumberOfComments) + ")", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon-wrapper" }, [
        _createElementVNode("span", { class: "material-icons icon" }, "textsms")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("textarea", {
          ref: "textarea",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newComment) = $event)),
          placeholder: _ctx.placeholderText,
          id: "new-comment-text-area",
          class: "new-comment-text",
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hasFocus = true)),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.textAreaBlur && _ctx.textAreaBlur(...args)))
        }, "        ", 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [
          [_vModelText, _ctx.newComment]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["new-comment-toolbar", { hide: !_ctx.hasFocus }])
        }, [
          _createVNode(_component_offer_button, {
            class: "send-button",
            text: _ctx.sendComment,
            color: "var(--primary-color)",
            icon: "send",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.postComment()))
          }, null, 8 /* PROPS */, ["text"])
        ], 2 /* CLASS */)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allOfferComments, (comment) => {
      return (_openBlock(), _createBlock(_component_comment, {
        key: comment.id,
        comment: comment
      }, null, 8 /* PROPS */, ["comment"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}